import React, { useMemo } from "react";
import { TopSourcesBody } from "./components";
const formatPercentage = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return Number(value.toFixed(1));
    }
    return "-";
};
const formatCount = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return Math.round(value);
    }
    return "-";
};
const parseNumberValue = (value) => {
    if (typeof value === "number" && Number.isFinite(value))
        return value;
    if (typeof value === "string") {
        const parsed = Number.parseFloat(value);
        if (Number.isFinite(parsed))
            return parsed;
    }
    return null;
};
// Below this a source carries too little weight to act on. Exported because the quadrant and the
// print template filter on the same rule, and three copies of the number would drift apart.
export const MIN_CITATION_WEIGHT = 3;
const filterSourcesByCitationWeight = (sources) => sources.filter((source) => {
    const weight = parseNumberValue(source.citationWeight);
    return weight !== null && weight >= MIN_CITATION_WEIGHT;
});
const mapSources = (sources, rankOffset = 0) => sources.map((source, index) => {
    var _a, _b, _c;
    return ({
        rank: rankOffset + index + 1,
        name: source.source,
        citationWeight: formatPercentage(source.citationWeight),
        citationWeightChange: (_a = source.citationWeightChange) !== null && _a !== void 0 ? _a : null,
        topPerformerCitations: formatCount(source.topPerformerCitations),
        yourCitations: formatCount(source.yourCitations),
        gap: formatPercentage(source.gap),
        gapChange: (_b = source.gapChange) !== null && _b !== void 0 ? _b : null,
        yourCitationsChange: (_c = source.yourCitationsChange) !== null && _c !== void 0 ? _c : null,
        status: source.status,
    });
});
export const TopSources = ({ topSources, rankOffset = 0, highlightedSourceName, scrollToSourceName, onRowHover, }) => {
    const sources = useMemo(() => {
        if (!(topSources === null || topSources === void 0 ? void 0 : topSources.length))
            return [];
        const filtered = filterSourcesByCitationWeight(topSources);
        return mapSources(filtered, rankOffset);
    }, [topSources, rankOffset]);
    if (!sources.length) {
        return null;
    }
    return (React.createElement(TopSourcesBody, { sources: sources, highlightedSourceName: highlightedSourceName, scrollToSourceName: scrollToSourceName, onRowHover: onRowHover }));
};
export default TopSources;
